<template>
  <div class="establish">
    <div class="top-row">
      <p class="tips">
        <i class="el-icon-info"></i>
        <span>提交流程(模拟搭建除外)只能由团队队长操作</span>
      </p>
      <el-button
        class="submit-btn"
        type="primary"
        size="medium"
        @click="handleSubmit"
        :disabled="!teamInfo.isCaptain"
        >提 交</el-button
      >
    </div>

    <div class="left">
      <h3 class="title">抖音账号模拟搭建：</h3>
      <div class="preview-wrapper">
        <iframe class="preview-content" :src="url" frameborder="0" />
      </div>
    </div>
    <div class="right">
      <div class="item">
        <h3 class="title">
          抖音封面：<span class="title-tips"
            >（在抖音账号建账号，并上传截图）
          </span>
        </h3>
        <el-upload
          class="uploader"
          :class="{ disabled: !teamInfo.isCaptain }"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleUpload"
          :disabled="!teamInfo.isCaptain"
        >
          <el-image
            class="upload-img"
            v-if="params.dyImg"
            :src="params.dyImg"
            fit="contain"
          ></el-image>
          <i v-else class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div class="item">
        <h3 class="title">抖音账号授权：</h3>
        <div>
          当前状态：
          <el-tag
            type="success"
            size="medium"
            v-if="
              teamInfo.douyinAccessTokenExpireDate &&
              verDate(teamInfo.douyinAccessTokenExpireDate)
            "
            >已授权</el-tag
          >
          <el-tag
            type="warning"
            size="medium"
            v-else-if="
              teamInfo.douyinAccessTokenExpireDate &&
              !verDate(teamInfo.douyinAccessTokenExpireDate)
            "
            >授权已过期</el-tag
          >
          <el-tag type="danger" size="medium" v-else>未绑定</el-tag>
        </div>
        <el-button
          type="primary"
          size="medium"
          style="margin-top: 20px"
          @click="showTiktok = true"
          :disabled="!teamInfo.isCaptain"
          >绑定抖音号</el-button
        >
      </div>
    </div>
    <el-dialog
      title="抖音号授权"
      :visible.sync="showTiktok"
      class="tiktok-dialog"
      width="300px"
      center
      destroy-on-close
    >
      <p class="tips">
        <i class="el-icon-warning-outline"></i>
        请用手机抖音扫码后,进行授权操作
      </p>
      <div id="qrCode" ref="qrCodeDiv"></div>
    </el-dialog>
  </div>
</template>

<script>
import upload from "@/utils/uploadMethod";
import QRCode from "qrcodejs2";
import { myTeam, getTiktokCode, tiktokCodeState } from "@/api/team";
import { myTeamInfo, submit } from "@/api/projectPractice/accountEstablish";
export default {
  data() {
    return {
      teamInfo: {},
      fileType: [],
      params: {},
      showTiktok: false,
    };
  },
  created() {
    this.getMyTeam();
    this.getInfo();
  },
  computed: {
    url() {
      return process.env.BASE_URL + "simulation/douyin/register/index";
    },
  },
  watch: {
    showTiktok(val) {
      if (val) {
        this.$loading.show();
        getTiktokCode({ classId: this.$route.query.id }).then(
          ({ code, data, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.timer && clearInterval(this.timer);
              this.timer = setInterval(() => {
                this.verCode(data);
              }, 3000);

              this.$nextTick(() => {
                this.bindQRCode(
                  `${process.env.VUE_APP_API_DOMAIN}/app/douyin/auth?code=${data}`
                );
              });
            } else {
              this.$message.error(msg);
            }
          }
        );
      } else {
        clearInterval(this.timer);
      }
    },
  },
  methods: {
    // 团队搭建信息
    getInfo() {
      this.$loading.show();
      myTeamInfo({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.params = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 上传图片
    async handleUpload(file) {
      const fileUrl = await upload(file);
      this.params.dyImg = fileUrl;
    },
    // 我的团队
    getMyTeam() {
      myTeam({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.teamInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    verDate(date) {
      let now = new Date().getTime();
      let checkDate = new Date(date).getTime();
      return checkDate - now > 0 ? true : false;
    },
    // 验证授权码状态
    verCode(code) {
      tiktokCodeState({ code }).then(({ code, data, msg }) => {
        if (code == 0) {
          if (data == 3) {
            this.showTiktok = false;
            this.$message.success("授权成功");
            this.getMyTeam();
          } else if (!data) {
            this.$message.warning("二维码已失效");
            this.showTiktok = false;
          }
        } else {
          console.log(msg);
        }
      });
    },
    // 二维码生成
    bindQRCode(text) {
      new QRCode(this.$refs.qrCodeDiv, {
        text,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
    handleSubmit() {
      if (!this.params.dyImg) {
        this.$message.warning("请上传抖音封面");
        return;
      } else if (
        !this.teamInfo.douyinAccessTokenExpireDate ||
        !this.verDate(this.teamInfo.douyinAccessTokenExpireDate)
      ) {
        this.$message.warning("请进行抖音号授权操作");
        return;
      }

      this.$confirm("确定要提交搭建信息吗?", {
        type: "warning",
      })
        .then(() => {
          this.params.classId = this.$route.query.id;
          this.$loading.show();
          submit(this.params).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getInfo();
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.establish {
  text-align: left;
  .top-row {
    overflow: hidden;
    .tips {
      float: left;
      margin-left: 20px;
      margin-bottom: 10px;
      color: #f56c6c;
      .el-icon-info {
        margin-right: 5px;
      }
    }
    .submit-btn {
      float: right;
    }
  }

  .left {
    display: inline-block;
    padding-right: 40px;
    border-right: dashed 1px #dcdfe6;
    .title {
      padding-left: 20px;
    }
    .preview-wrapper {
      position: relative;
      width: 377px;
      height: 812px;
      background-image: url("../../../../assets/images/simulation/phone.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .preview-content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 350px;
      height: 660px;
      overflow: auto;
    }
  }
  .right {
    display: inline-block;
    padding-left: 40px;
    vertical-align: top;
    .item {
      margin-bottom: 30px;
      .title {
        margin-bottom: 15px;
        .title-tips {
          font-size: 14px;
          color: #909399;
        }
      }
      .uploader {
        width: 240px;
        height: 400px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        text-align: center;
        position: relative;
        overflow: hidden;
        &.disabled {
          background-color: #f5f7fa;
          .el-icon-plus {
            cursor: not-allowed;
          }
          &:hover {
            border-color: #d9d9d9;
            .el-icon-plus {
              color: #8c939d;
            }
          }
        }

        &:hover {
          border-color: #409eff;
          .el-icon-plus {
            color: #409eff;
          }
        }

        .el-icon-plus {
          width: 240px;
          height: 400px;
          font-size: 38px;
          color: #8c939d;
          line-height: 400px;
          text-align: center;
          cursor: pointer;
        }
        .upload-img {
          width: 240px;
          height: 400px;
          display: block;
        }
      }
    }
  }
  ::v-deep .tiktok-dialog {
    .el-dialog__body {
      text-align: center;
    }
    .tips {
      margin-bottom: 10px;
      color: #f56c6c;
    }
    #qrCode {
      img {
        display: inline-block !important;
      }
    }
  }
}
</style>